import axios from 'axios';
import type { OrganizationData } from '@/lib/organization';

const BASE_URL = `${process.env.VUE_APP_API_ROOT}/organizations`;

interface AllResponse {
  data: OrganizationData[],
  success: boolean,
}

interface GetResponse {
  data: OrganizationData,
  success: boolean,
}


interface DeleteResponse {
  success: boolean,
}

export const organizationService = {
  async getAll(): Promise<OrganizationData[]> {
    const res = await axios.get<AllResponse>(BASE_URL);
    return res.data.data;
  },

  async getOne(slug: string): Promise<OrganizationData> {
    const res = await axios.get<GetResponse>(`${BASE_URL}/${slug}`);
    return res.data.data;
  },

  async add(data: OrganizationData): Promise<any> {
    const res = await axios.post<OrganizationData>(
      BASE_URL,
      data, {
      validateStatus: () => true,
    });
    return res.data
  },

  async update(slug: string, data: OrganizationData): Promise<any> {
    const res = await axios.put<OrganizationData>(
      `${BASE_URL}/${slug}`,
      data, {
        validateStatus: () => true,
      }
    );
    return res.data
  },

  async delete(slug: string): Promise<boolean> {
    const res = await axios.delete<DeleteResponse>(`${BASE_URL}/${slug}`);
    return res.data.success;
  },

}


